export default __webpack_public_path__ + "static/media/homeSaibaMaisScale.3a85d69e.png";